import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import { HttpErrorResponse } from '../model/httperror-response';

@Injectable()
export class HttpResponseService {
    httpErrorResponse$: BehaviorSubject<HttpErrorResponse> = new BehaviorSubject(new HttpErrorResponse(0,''));
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/httpresponse-service.ts